<template>
  <div class="diandianrentou-container">
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-one">
          <a-button class="btn-primary" @click="handleRefresh">刷新数据</a-button>
          <a-button class="btn-primary" style="margin-left: 8px;" @click="handleShowLog">查看日志</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-input-search
              v-model:value="searchForm.name"
              :loading="searchLoading"
              placeholder="请输入设备名称"
              @search="getTableList"
          >
          </a-input-search>
        </div>
        <div class="rig-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
    </div>

    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ y: tableHeight }"
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'name'">
          <div class="device-name">
            <div class="name-text">{{ record.name }}</div>
            <div class="su-an-code f-c-999 f-12">{{ record.su_an_code }}</div>
          </div>
        </template>
        <template v-if="column.key == 'in_out_count'">
          <div class="in-out-info">
            <div class="in-count">
              <span class="label">进入:</span>
              <span class="num green">{{ record.in_count || 0 }}</span>
            </div>
            <div class="out-count">
              <span class="label">出去:</span>
              <span class="num red">{{ record.out_count || 0 }}</span>
            </div>
          </div>
        </template>
        <template v-if="column.key == 'cloud_connect_state'">
          <a-tag :color="record.cloud_connect_state === 1 ? 'green' : 'red'">
            {{ record.cloud_connect_state === 1 ? '已连接' : '未连接' }}
          </a-tag>
        </template>
        <template v-if="column.key == 'rent_state'">
          <a-tag :color="record.rent_state === 2 ? 'green' : 'default'">
            {{ record.rent_state === 2 ? '已租' : '未租' }}
          </a-tag>
        </template>
        <template v-if="column.key == 'risk_state'">
          <a-tag :color="record.risk_state === 1 ? 'red' : 'green'">
            {{ record.risk_state === 1 ? '有风险' : '正常' }}
          </a-tag>
        </template>
        <template v-if="column.key == 'count_time'">
          <div class="time-info">
            <div v-if="record.count_time">{{ formatTime(record.count_time) }}</div>
            <div v-else class="f-c-999">--</div>
          </div>
        </template>
        <template v-if="column.key == 'operate'">
          <a-button size="small" type="link" @click="handleDetail(record)">详情</a-button>
        </template>
      </template>
    </a-table>

    <MyPagination
        :pageTotal="pageTotal"
        :current="searchForm.page_num"
        :pageSize="searchForm.page_size"
        @pageChange="pageChange"
        @onShowSizeChange="onShowSizeChange"
    />

    <a-modal
        v-model:visible="visibleDetail"
        :footer="null"
        :width="700"
        title="设备详情"
    >
      <a-descriptions :column="2" bordered size="small">
        <a-descriptions-item label="设备名称">{{ detailData.name || '--' }}</a-descriptions-item>
        <a-descriptions-item label="MAC地址">{{ detailData.mac || '--' }}</a-descriptions-item>
        <a-descriptions-item label="云端连接状态">
          <a-tag :color="detailData.cloud_connect_state === 1 ? 'green' : 'red'">
            {{ detailData.cloud_connect_state === 1 ? '已连接' : '未连接' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="统计时间">
          {{ detailData.count_time ? formatTime(detailData.count_time) : '--' }}
        </a-descriptions-item>
        <a-descriptions-item label="进入人数">
          <span class="f-c-green f-16">{{ detailData.in_count || 0 }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="出去人数">
          <span class="f-c-red f-16">{{ detailData.out_count || 0 }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="登记人数">
          <span class="f-16">{{ detailData.checkin_count || 0 }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="实时人数">
          <span class="f-16" :class="{ 'f-c-red': detailData.real_count > detailData.checkin_count }">
            {{ detailData.real_count || 0 }}
          </span>
          <span v-if="detailData.real_count > detailData.checkin_count" class="f-c-red f-12" style="margin-left: 8px;">
            (超出登记人数)
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="成年女性概率">{{ detailData.per_female || 0 }}%</a-descriptions-item>
        <a-descriptions-item label="女童概率">{{ detailData.per_girl || 0 }}%</a-descriptions-item>
        <a-descriptions-item label="男童概率">{{ detailData.per_boy || 0 }}%</a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <a-modal
        v-model:visible="visibleLog"
        :footer="null"
        :width="1200"
        title="日志查询"
    >
      <div class="log-filter">
        <a-range-picker
            v-model:value="logFilter.dateRange"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            style="margin-right: 8px;"
        />
        <a-input
            v-model:value="logFilter.name"
            placeholder="设备名称"
            style="width: 150px; margin-right: 8px;"
        />
        <a-button type="primary" @click="handleLogSearch">查询</a-button>
      </div>
      <a-table
          :columns="logColumns"
          :dataSource="logDataSource"
          :loading="logLoading"
          :pagination="false"
          :scroll="{ y: 400 }"
          size="small"
          style="margin-top: 16px;"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key == 'count_time'">
            <div v-if="record.count_time">{{ formatTime(record.count_time) }}</div>
            <div v-else class="f-c-999">--</div>
          </template>
          <template v-if="column.key == 'create_time'">
            <div v-if="record.create_time">{{ record.create_time }}</div>
            <div v-else class="f-c-999">--</div>
          </template>
          <template v-if="column.key == 'in_out_count'">
            <div class="in-out-info">
              <div class="in-count">
                <span class="label">进入:</span>
                <span class="num green">{{ record.in_count || 0 }}</span>
              </div>
              <div class="out-count">
                <span class="label">出去:</span>
                <span class="num red">{{ record.out_count || 0 }}</span>
              </div>
            </div>
          </template>
          <template v-if="column.key == 'real_count'">
            <span :class="{ 'f-c-red': record.real_count > record.checkin_count }">
              {{ record.real_count || 0 }}
            </span>
          </template>
          <template v-if="column.key == 'count_img'">
            <a-image
                v-if="record.count_img"
                :src="'https://lanq.fun/hc/file' + record.count_img"
                :width="60"
                :height="40"
                style="object-fit: cover; cursor: pointer;"
            />
            <span v-else class="f-c-999">--</span>
          </template>
        </template>
      </a-table>
      <div class="log-pagination">
        <a-pagination
            :current="logPagination.current"
            :pageSize="logPagination.pageSize"
            :total="logPagination.total"
            :show-total="(total) => `共 ${total} 条`"
            show-size-changer
            @change="handleLogPageChange"
            @showSizeChange="handleLogSizeChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import {onMounted, reactive, toRefs, watch} from "vue";
import {GetDeviceList, GetDeviceInfo, GetLogList} from "@/api/api";
import useUtils from "@/hooks/useUtils.js";
import store from "@/store/pms/landlord/index";
import dayjs from "dayjs";

export default {
  name: 'diandianrentou',
  setup() {
    let {countTable} = useUtils();

    let search = reactive({
      topDom: "",
      searchForm: {
        name: "",
        page_size: 10,
        page_num: 1,
      },
      searchLoading: false,
      handleReset() {
        search.searchForm.name = "";
        search.searchForm.page_num = 1;
        table.getTableList();
      },
    });

    let table = reactive({
      tableHeight: "",
      dataSource: [],
      columns: [
        {
          title: "设备名称",
          dataIndex: "name",
          key: "name",
          width: 200,
        },
        {
          title: "进出统计",
          dataIndex: "in_out_count",
          key: "in_out_count",
          width: 120,
        },
        {
          title: "云连接状态",
          dataIndex: "cloud_connect_state",
          key: "cloud_connect_state",
          width: 100,
        },
        {
          title: "出租状态",
          dataIndex: "rent_state",
          key: "rent_state",
          width: 100,
        },
        {
          title: "风险状态",
          dataIndex: "risk_state",
          key: "risk_state",
          width: 100,
        },
        {
          title: "统计时间",
          dataIndex: "count_time",
          key: "count_time",
          width: 180,
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          width: 80,
        },
      ],
      getTableList() {
        debugger
        search.searchLoading = true;
        GetDeviceList({
          page_size: search.searchForm.page_size,
          page_num: search.searchForm.page_num,
        })
            .then((res) => {
              let list = [];
              let total = 0;
              if (res && res.data && res.data.content) {
                list = res.data.content.list || [];
                total = res.data.content.count || 0;
              }
              if (search.searchForm.name) {
                list = list.filter(item => item.name && item.name.includes(search.searchForm.name));
              }
              table.dataSource = list;
              pagination.pageTotal = total;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      handleRefresh() {
        table.getTableList();
      },
    });

    let modal = reactive({
      visibleDetail: false,
      detailData: {},
      handleDetail(record) {
        let params = {};
        if (record.su_an_code) {
          params.su_an_code = record.su_an_code;
        } else {
          params.name = record.name;
        }
        GetDeviceInfo(params).then((res) => {
          if (res.data && res.data.content) {
            modal.detailData = res.data.content;
          } else {
            modal.detailData = record;
          }
          modal.visibleDetail = true;
        }).catch(() => {
          modal.detailData = record;
          modal.visibleDetail = true;
        });
      },
    });

    let logModal = reactive({
      visibleLog: false,
      logLoading: false,
      logFilter: {
        dateRange: null,
        name: "",
      },
      logColumns: [
        { title: "设备名称", dataIndex: "name", key: "name", width: 100 },
        { title: "苏安码", dataIndex: "su_an_code", key: "su_an_code", width: 200 },
        { title: "进出统计", dataIndex: "in_out_count", key: "in_out_count", width: 120 },
        { title: "登记人数", dataIndex: "checkin_count", key: "checkin_count", width: 80 },
        { title: "实时人数", dataIndex: "real_count", key: "real_count", width: 80 },
        { title: "统计时间", dataIndex: "count_time", key: "count_time", width: 180 },
        { title: "图片", dataIndex: "count_img", key: "count_img", width: 100 },
        { title: "创建时间", dataIndex: "create_time", key: "create_time", width: 180, },
      ],
      logDataSource: [],
      logPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      handleShowLog() {
        logModal.logFilter.dateRange = null;
        logModal.logFilter.name = "";
        logModal.logPagination.current = 1;
        logModal.logPagination.pageSize = 10;
        logModal.visibleLog = true;
        logModal.getLogList();
      },
      handleLogSearch() {
        logModal.logPagination.current = 1;
        logModal.getLogList();
      },
      getLogList() {
        logModal.logLoading = true;
        const params = {
          page_size: logModal.logPagination.pageSize,
          page_num: logModal.logPagination.current,
        };
        if (logModal.logFilter.name) {
          params.name = logModal.logFilter.name;
        }
        if (logModal.logFilter.dateRange && logModal.logFilter.dateRange.length === 2) {
          params.start_time = dayjs(logModal.logFilter.dateRange[0]).format("YYYY-MM-DD HH:mm:ss");
          params.end_time = dayjs(logModal.logFilter.dateRange[1]).format("YYYY-MM-DD HH:mm:ss");
        }
        GetLogList(params)
            .then((res) => {
              let list = [];
              let total = 0;
              if (res && res.data) {
                if (Array.isArray(res.data)) {
                  list = res.data;
                  total = res.data.length;
                } else {
                  list = res.data.list || [];
                  total = res.data.total || 0;
                }
                list = list.map(item => ({
                  ...item,
                  create_time: item.create_time || "--",
                }));
              }
              logModal.logDataSource = list;
              logModal.logPagination.total = total;
              logModal.logLoading = false;
            })
            .catch(() => {
              logModal.logLoading = false;
            });
      },
      handleLogPageChange(page, pageSize) {
        logModal.logPagination.current = page;
        logModal.logPagination.pageSize = pageSize;
        logModal.getLogList();
      },
      handleLogSizeChange(current, size) {
        logModal.logPagination.current = 1;
        logModal.logPagination.pageSize = size;
        logModal.getLogList();
      },
    });

    const formatTime = (timestamp) => {
      if (!timestamp) return "--";
      return dayjs(Number(timestamp)).format("YYYY-MM-DD HH:mm:ss");
    };

    const formatTimestamp = (timestamp) => {
      if (!timestamp) return "--";
      return dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
    };

    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.page_num = value;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.page_size = value;
        search.searchForm.page_num = 1;
        table.getTableList();
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 10;
        }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(logModal),
      ...toRefs(pagination),
      formatTime,
      formatTimestamp,
    };
  },
};
</script>

<style lang="scss" scoped>
.diandianrentou-container {
  padding: 0;
}

.device-name {
  .name-text {
    font-weight: 500;
  }

  .su-an-code {
    margin-top: 4px;
  }
}

.in-out-info {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .in-count, .out-count {
    .label {
      color: #999;
    }

    .num {
      font-weight: 500;
      margin-left: 4px;

      &.green {
        color: #52c41a;
      }

      &.red {
        color: #ff4d4f;
      }
    }
  }
}

.time-info {
  font-size: 12px;
  color: #666;
}

.f-c-red {
  color: #ff4d4f;
}

.f-c-green {
  color: #52c41a;
}

.f-c-999 {
  color: #999;
}

.f-12 {
  font-size: 12px;
}

.f-16 {
  font-size: 16px;
  font-weight: 500;
}

.log-filter {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.log-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
